import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=5ddf6446&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddf6446"]])

export default __exports__